// Ensure `window` is defined in non-browser environments
if (typeof window === 'undefined') {
  global.window = { location: { host: 'localhost' } };
}

// Environment mapping
const environmentMap = {
  'chula.airpresense.tech': 'chula',
  'dip.airpresense.tech': 'chula',
  'bangpra.airpresense.tech': 'bangpra',
  'phyathai.airpresense.tech': 'bangpra',
  'banbangkhae.airpresense.tech': 'banbangkhae',
  'dop.airpresense.tech': 'dop',
  'webtest002.codesand.cloud': 'dop-gdcc',
  'localhost': 'localhost',
  '192.168.1.100': 'localServer',
};

// Determine environment based on the host
const host = window.location.host;
const env = environmentMap[host] || 'develop';

// Dynamically import the configuration based on the environment
const config = require(`./config/config.${env}`);

// Export the configuration
export default config;
